import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Row, Col, Form, Button } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import axios from "axios";

function ViewUsetDetails() {
  const { id } = useParams();
  const location = useLocation();

  const users = location.state?.user;

  const [formState, setFormState] = useState({
    from_date: "",
    to_date: "",
  });

  const [error, setError] = useState("");
  const userId = users?.id;
  const [data, setData] = useState(null);
  const AuthToken = localStorage.getItem("AuthUser");

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedState = {
      ...formState,
      [name]: value,
    };
    setFormState(updatedState);

    const { from_date, to_date } = updatedState;
    if (
      (from_date && to_date && new Date(to_date) >= new Date(from_date)) ||
      (!from_date && !to_date)
    ) {
      setError("");
    }
  };

  const handleApplyFilter = async () => {
    const { from_date, to_date } = formState;
    if (!from_date && !to_date) {
      setError("Please enter from_date and to_date.");
      return;
    }
    if (from_date && !to_date) {
      setError("Please select a 'To Date' when 'From Date' is chosen.");
      return;
    }
    if (!from_date && to_date) {
      setError("Please select a 'From Date' when 'To Date' is chosen.");
      return;
    }
    if (from_date && to_date && new Date(to_date) < new Date(from_date)) {
      setError("'To Date' cannot be earlier than 'From Date'.");
      return;
    }
    setError("");
    try {
      axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
      const params = {};
      if (formState?.from_date) params.from_date = formState.from_date;
      if (formState?.to_date) params.to_date = formState.to_date;
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/user-report/${userId}`,
        { params }
      );
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleClearFilter = async () => {
    try {
      setFormState({
        from_date: "",
        to_date: "",
      });
      setError("");
      axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/user-report/${userId}`
      );
      setData(response.data);
    } catch (error) {
      console.error("Error clearing filter:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/user-report/${userId}`
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    if (userId) {
      fetchData();
    }
  }, [userId, AuthToken]);

  const user = data?.user;
  const per = data?.user?.permissions;

  if (!users) {
    return (
      <div className="p-4 text-center">
        <h4>No user data found. Please go back.</h4>
      </div>
    );
  }

  return (
    <PageLayout>
      <div className="p-4">
        <h5 className="mc-divide-title mb-4">
          <small>User Name: {user?.name}</small>
        </h5>
        <Row>
          <div className="mb-1">
            <h5 className="fw-bold mb-0">Filter by Date</h5>
          </div>
          <Row className="align-items-center g-3">
            <Col md="auto">
              <Form.Label className="mb-0">From:</Form.Label>
            </Col>
            <Col md={3}>
              <Form.Control
                name="from_date"
                type="date"
                value={formState.from_date}
                onChange={handleChange}
              />
            </Col>
            <Col md="auto">
              <Form.Label className="mb-0">To:</Form.Label>
            </Col>
            <Col md={3}>
              <Form.Control
                name="to_date"
                type="date"
                value={formState.to_date}
                onChange={handleChange}
              />
            </Col>
            <Col md="2">
              <Button
                onClick={handleApplyFilter}
                style={{
                  backgroundColor: "#077834",
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                Apply Filter
              </Button>
            </Col>
            <Col md="2">
              <Button
                onClick={handleClearFilter}
                className="bg-secondary"
                style={{ fontWeight: "bold", fontSize: "12px" }}
              >
                Clear Filter
              </Button>
            </Col>
          </Row>
          {error && (
            <div className="text-danger mt-2" style={{ fontSize: "13px" }}>
              {error}
            </div>
          )}
        </Row>
        <Row>
          {per?.map((p, index) => (
            <Col md={4} key={index} className="mb-3 mt-3">
              <div
                className="mc-ecommerce-card"
                style={{
                  background:
                    "linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
                  cursor: "pointer",
                }}
              >
                <i className="mc-ecommerce-card-trend material-icons">
                  trending_up
                </i>
                <div className="mc-ecommerce-card-head">
                  <h4 className="mc-ecommerce-card-meta">
                    <span>{p.name}</span>
                    <span className="text-white">Count : 1</span>
                  </h4>
                  <i className="mc-ecommerce-card-icon material-icons">lock</i>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </PageLayout>
  );
}

export default ViewUsetDetails;
